import apiFetch from '../../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'DossierCancel', method: 'GET', token: token })
}
